import { render, staticRenderFns } from "./StokListesiXml.vue?vue&type=template&id=24d13724"
import script from "./StokListesiXml.vue?vue&type=script&lang=js"
export * from "./StokListesiXml.vue?vue&type=script&lang=js"
import style0 from "./StokListesiXml.vue?vue&type=style&index=0&id=24d13724&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports